import React from 'react';

const SkeletonSingleProduct = ({color}) => {
    return (
        <div className={"skeleton-single-product br-4 position-relative skeleton-loading " + color}>
            <div className="price-box position-absolute skeleton-loading"></div>
            <div className="circle-box skeleton-loading"></div>
            <div className="text br-2 text-sk--1 skeleton-loading xmt-14"></div>
            <div className="text br-2 text-sk--2 skeleton-loading xmt-2"></div>
        </div>
    );
};

export default SkeletonSingleProduct;